import { create } from 'zustand';
// import { persist } from 'zustand/middleware';
import { Delta as TypeDelta } from 'quill';

// import { Storages } from 'src/appConstants';
import { EventCategory } from 'src/types/dto';

import {
	EventScheduleValue,
	HowMuchFormValues,
	WhereFormValues,
} from '../types/types';
import { ImageUploadValue } from 'src/components/cropImage/ImageUpload';

export type EventDraft = {
	id: string;
	banner: ImageUploadValue | null;
	name: string;
	category: EventCategory | null;
	hidden: 'true' | 'false';
	description: string | TypeDelta | undefined;
	schedules: EventScheduleValue[];
	place: WhereFormValues;
	placeId: number;
	ticketTypes: { [groupId: string]: HowMuchFormValues[] };
	ticketsTax: number;
};

type EventNewStore = {
  draft: Partial<EventDraft>;
  isEditing: boolean;
  isEventCreated: boolean;
  hasInteractedWithForm: boolean;
  hasTrackedLead: boolean;
  hasTrackedBannerLead: boolean; 
  hasTrackedNameLead: boolean; 
  lastNameLength: number;
  hasEvent: boolean; 
  updateDraft: (
    callback: (draft: Partial<EventDraft>) => Partial<EventDraft>,
  ) => void;
  resetState: () => void;
  setEditing: (isEditing: boolean) => void;
  setIsEventCreated: (isEventCreated: boolean) => void;
  setHasInteractedWithForm: (hasInteracted: boolean) => void;  
  setHasTrackedLead: (hasTracked: boolean) => void;
  setHasTrackedBannerLead: (hasTracked: boolean) => void;
  setHasTrackedNameLead: (hasTracked: boolean) => void;
  setLastNameLength: (length: number) => void;
  setHasEvent: (hasEvent: boolean) => void; 
};

const useEventNewStore = create<EventNewStore>(
  set => ({
    draft: {},
    isEditing: false,
    isEventCreated: false,
    hasInteractedWithForm: false,
    hasTrackedLead: false,
    hasTrackedBannerLead: false,
    hasTrackedNameLead: false,
    lastNameLength: 0,
    hasEvent: false, 

    updateDraft: callback =>
      set(prev => ({
        ...prev,
        draft: typeof callback === 'function' ? callback(prev.draft) : callback,
      })),
    resetState: () => set({ 
      draft: {}, 
      isEditing: false, 
      isEventCreated: false,
      hasInteractedWithForm: false, 
      hasTrackedLead: false,
      hasTrackedBannerLead: false, 
      hasTrackedNameLead: false,
      lastNameLength: 0,
      hasEvent: false 
    }),
    setEditing: isEditing => set({ isEditing }),
    setIsEventCreated: isEventCreated => set({ isEventCreated }),
    setHasInteractedWithForm: hasInteractedWithForm => set({ hasInteractedWithForm }),
    setHasTrackedLead: hasTrackedLead => set({ hasTrackedLead }),
    setHasTrackedBannerLead: hasTrackedBannerLead => set({ hasTrackedBannerLead }),
    setHasTrackedNameLead: hasTrackedNameLead => set({ hasTrackedNameLead }),
    setLastNameLength: lastNameLength => set({ lastNameLength }),
    setHasEvent: hasEvent => set({ hasEvent }),
  })
);

export default useEventNewStore;